import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  panel: {
    minHeight: 200,
  },
});

export default useStyles;
